// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper__u2i7a3ib"};